module.exports = __webpack_public_path__ + "assets/img/download.aa7fabfb.png";